/*
 * Copyright (c) 2023. Nedaware SL
 */

import {Resource} from "../../api/resource";
import {BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {ExactSearchFilter} from "../../basic-entity-back/filters/search-filter";
import {Cliente} from "../personas/cliente.model";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {BaseEntity} from "../base-entity.model";

export abstract class Documento extends BaseEntity {
    @BasicProperty({
        name: 'ID',
        isId: true,
        type: PropertyType.Integer()
    })
    private _id;

    @BasicProperty({
        name: 'Importe',
        type: PropertyType.Financial(2)
    })
    private _importeTotal: number = 0;

    @BasicProperty({
        name: 'Cliente',
        type: PropertyType.NestedModel(Cliente, null, NestedBehavior.SendIriOnly),
        filters: [ExactSearchFilter]
    })
    private _cliente;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get importeTotal(): number {
        return this._importeTotal;
    }

    set importeTotal(value: number) {
        this._importeTotal = value;
    }

    get cliente() {
        return this._cliente;
    }

    set cliente(value) {
        this._cliente = value;
    }
}
